export function readableNum(num) {
  if (typeof num === 'string') {
    num = parseInt(num)
  }
  if (num < 10000) {
    return num + ''
  }

  let precise = 1;
  if (num > 100000) {
    precise = 0
  }
  num = (num / 10000).toFixed(precise);
  num = num.replace(/\.0*$/, '')
  return num + '万'
}

//
// console.assert(readableNum(1000) === '1000')
// console.assert(readableNum(10000) === '1万')
// console.assert(readableNum(10010) === '1万')
// console.assert(readableNum(11010) === '1.1万')
// console.assert(readableNum(111010) === '11万')





// WEBPACK FOOTER //
// ./src/tools/numFormat.js